import React from 'react';

const MOCK_POINTS = [
  { name: 'Room Temperature', type: 'Number · °C', value: '22.5 °C' },
  { name: 'AC Fan Speed',     type: 'Number · %',  value: '65%' },
  { name: 'AC Mode',          type: 'Enum',         value: 'Cool' },
  { name: 'Occupancy',        type: 'Boolean',      value: 'Occupied' },
  { name: 'Humidity',         type: 'Number · %',  value: '47%' },
];

const PROTOCOLS = ['BACnet', 'MQTT', 'KNX', 'Haystack', 'REST API'];

const FEATURES = [
  'Direct read/write to Desigo Optic data points via secure API',
  'Project and site hierarchy mapped from Desigo Optic structure',
  'Live sensor streaming via WebSocket subscription',
  'Edge2Cloud remote access — no VPN required',
  'Write-level control with priority override',
  'Supports Bool, Number, Enum, and String point types',
];

const SiemensSection = () => (
  <section className="siemens-section" id="siemens">
    <div className="siemens-inner">
      <div className="siemens-text">
        <span className="siemens-badge">Powered by Siemens</span>
        <h2>Built on Desigo Optic —<br />The Open BMS Standard</h2>
        <p>
          Siemens Desigo Optic is an enterprise building management platform trusted across
          hospitals, hotels, airports, and residential complexes globally. Manzili Smart connects
          natively to Desigo Optic, exposing its full data point hierarchy through a clean,
          consumer-grade interface.
        </p>

        <ul className="siemens-features">
          {FEATURES.map(f => (
            <li key={f}>
              <span className="feat-check" />
              {f}
            </li>
          ))}
        </ul>

        <div className="siemens-protocols">
          {PROTOCOLS.map(p => (
            <span className="proto-tag" key={p}>{p}</span>
          ))}
        </div>
      </div>

      <div className="siemens-visual">
        <div className="visual-header">
          <span className="visual-title">Live Point Data · AC Unit Floor 3</span>
          <div className="visual-live">
            <span className="live-dot" />
            <span>Live</span>
          </div>
        </div>

        <div className="mockup-points">
          {MOCK_POINTS.map(p => (
            <div className="mockup-point" key={p.name}>
              <div className="point-left">
                <span className="point-dot" />
                <div className="point-info">
                  <div className="point-name">{p.name}</div>
                  <div className="point-type">{p.type}</div>
                </div>
              </div>
              <span className="point-value">{p.value}</span>
            </div>
          ))}
        </div>

        <div className="mockup-footer">
          Desigo Optic · E2 Cloud · Manzili Smart Integration
        </div>
      </div>
    </div>
  </section>
);

export default SiemensSection;
